import type { WorkspaceMemberResponse } from '@optidev/shared-types';

interface OwnerCardProps {
  member: WorkspaceMemberResponse;
}

/**
 * Owner Card
 * The workspace owner, rendered above the role groups. Same grammar as a
 * member row (identity left, role right) — the primary-tinted surface alone
 * marks it special. Ownership actions live on admin rows (transfer), not here.
 */
export function OwnerCard({ member }: OwnerCardProps) {
  const displayName = member.user.displayName || member.user.email;
  const initials = displayName.charAt(0).toUpperCase();

  return (
    <div className="flex items-center gap-3.5 rounded-xl border border-primary/30 bg-primary/10 px-4 py-3.5">
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary text-sm font-semibold text-primary-foreground">
        {initials}
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <span className="truncate font-medium">{displayName}</span>
          {member.isCurrentUser && (
            <span className="text-xs text-muted-foreground">(you)</span>
          )}
        </div>
        {member.user.displayName && (
          <div className="truncate text-sm text-muted-foreground">
            {member.user.email}
          </div>
        )}
      </div>
      <span className="ml-auto flex-shrink-0 rounded-[5px] bg-primary px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary-foreground">
        Owner
      </span>
    </div>
  );
}
